import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const Processo = () => {
  const steps = [
    {
      number: '1',
      title: 'Contatto iniziale',
      description: 'Incontro per comprendere le vostre esigenze e presentare il nostro approccio.',
      duration: '1-2 settimane'
    },
    {
      number: '2',
      title: 'Analisi preliminare',
      description: 'Raccolta documentazione aziendale e verifica dell\'allineamento con i nostri criteri.',
      duration: '2-3 settimane'
    },
    {
      number: '3',
      title: 'Valutazione approfondita',
      description: 'Esame accurato della situazione economica e gestionale dell’azienda.',
      duration: '4-6 settimane'
    },
    {
      number: '4',
      title: 'Proposta strutturata',
      description: 'Presentazione di un’offerta chiara, dettagliata e con tempistiche definite.',
      duration: '2-3 settimane'
    },
    {
      number: '5',
      title: 'Passaggio e continuità',
      description: 'Finalizzazione dell\'operazione e accompagnamento dell’impresa.',
      duration: '3-4 settimane'
    }
  ];

  return (
    <section id="processo" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <div className="inline-block bg-blue-100 text-blue-900 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Il nostro processo
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Come lavoriamo con i nostri partner
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Un processo strutturato, trasparente e professionale dal primo contatto 
            fino alla finalizzazione dell'acquisto.
          </p>
        </div>

        {/* Process Steps */}
        <div className="max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="absolute left-16 top-24 bottom-0 w-0.5 bg-gray-200 hidden md:block"></div>
              )}

              <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12 group">
                {/* Number Circle */}
                <div className="md:col-span-2 flex md:justify-center">
                  <div className="relative z-10 w-32 h-32 bg-white border-4 border-blue-900 rounded-full flex items-center justify-center group-hover:bg-blue-900 transition-all duration-300 group-hover:scale-110">
                    <span className="text-3xl font-bold text-blue-900 group-hover:text-white transition-colors duration-300">
                      {step.number}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="md:col-span-10 bg-gray-50 rounded-2xl p-8 group-hover:shadow-xl transition-all duration-300 border-2 border-transparent group-hover:border-blue-900">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                    <h3 className="text-2xl font-bold text-gray-900 mb-2 md:mb-0">{step.title}</h3>
                    <span className="inline-flex items-center bg-blue-100 text-blue-900 px-4 py-2 rounded-full text-sm font-semibold">
                      <CheckCircle2 size={16} className="mr-2" />
                      {step.duration}
                    </span>
                  </div>
                  <p className="text-gray-600 leading-relaxed text-lg">{step.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Processo;